var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"w-100 h-100"},[_c('Nav',{attrs:{"rolname":_vm.rolname}})],1),_c('div',{staticClass:"content"},[(_vm.page == 'home')?_c('Home',{on:{"mtdChangePage":_vm.mtdChangePage,"mtdBackCampus":_vm.mtdBackCampus}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }